import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useKeycloak } from '@react-keycloak/web';
import { SDPContext } from 'Contexts';
import { Sidebar } from 'Components';
import { navigation } from 'Routes';

export default function Authorized({ children }) {
  const { keycloak } = useKeycloak();
  const { state } = useContext(SDPContext);

  let sidebarFooterActios = [
    {
      name: 'Logout',
      callback: () =>
        keycloak.logout({
          redirectUri: `${window.location.origin}/login`
        })
    }
  ];

  return (
    <div className="sdp-page-wrapper">
      <Sidebar
        navigation={navigation}
        open
        dropDir="right"
        actions={sidebarFooterActios}
        user={state?.user?.data}
      />
      <main className="sdp-main">{children}</main>
    </div>
  );
}

Authorized.propTypes = {
  children: PropTypes.node.isRequired
};
